export class Legion {
  id!: number;
}

export class Legions {
    public static LegionHumain: number = 5
    public static LegionEpouvantail: number = 0

    public values: Map<number, string> = new Map<number, string>([
        [0, "Epouvantail"],
        [1, "Vonstrogen"],
        [2, "Margul"],
        [3, "Vamnazul"],
        [4, "Lycan"],
        [5, "Humain"],
        [6, "Necropolitain"],
        [7, "Mentipede"],
        [8, "Escobar"]
    ]);

    public pointTolerance: Map<number, string> = new Map<number, string>([
        [0, "42"],
        [1, "42"],
        [2, "52"],
        [3, "2-6"],
        [4, "6-9"],
        [5, "4"],
        [6, "4"],
        [7, "4"],
        [8, "4"]
    ]);
}